import { routing } from "../../routing.js";
export function createClient(api) {
  async function create(newsroomId, payload) {
    const url = routing.newsroomPrivacyRequestsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      privacy_request
    } = await api.post(url, {
      payload
    });
    return privacy_request;
  }
  async function confirm(newsroomId, privacyRequestId) {
    const url = routing.newsroomPrivacyRequestsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      privacy_request
    } = await api.post(`${url}/${privacyRequestId}/confirm`);
    return privacy_request;
  }
  return {
    create,
    confirm
  };
}